<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
            <!-- <label>商品名称:</label>
            <lk-input clearable placeholder="请输入" v-model='query.approvedDrugName' class="item"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>收货单号:</label>
            <lk-input clearable placeholder="请输入" v-model='query.code' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <!-- <div class="queryItem">
            <label>商品编码:</label>
            <lk-input clearable placeholder="请输入" v-model='query.drugSerialCode' class="item"></lk-input>
          </div> -->
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import expandRow from './inspectionTableExpand.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'waitingReceipt',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, SupplierListSelect,
  },
  data() {
    return {
      showInspect: false,
      paymentType: ['普通', '寄售'],
      purchaseOrderStatus: ['待发货', '已部分收货', '已全部收货', '已全部验收', '交易取消'],
      query: {
        code: '',
        supplierName: '',
        supplierCode: '',
        approvedDrugName: '',
        drugSerialCode: '',
        supplierId: null,
        isDecoction: 2,
        goodsType: null, // 商品类型
        purchaseType: null, // 来源
      },
      createTime: new Date(),
      createUser: {
        createUserId: 0,
        createUserName: '阿大',
      },
      unqualifiedTypes: [{
        id: 1,
        name: '药品过期',
      }, {
        id: 2,
        name: '药监抽检',
      }, {
        id: 3,
        name: '药品损坏',
      }],
      unqualifiedType: null,
      addParams: [],
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, params) => h(expandRow, {
            props: {
              row: params.row,
              goodsType: params.row.purchaseReceiptGoodsType,
            },
          }),
        },
        {
          title: '收货单号',
          minWidth: 116,
          key: 'purchaseReceiptCode',
        },
        {
          title: '商品类型', key: 'purchaseReceiptGoodsTypeName', width: 116, tooltip: true,
        },
        {
          title: '来源', key: 'purchaseReceiptPurchaseTypeName', width: 116, tooltip: true,
        },
        {
          title: '供应商名称',
          minWidth: 116,
          key: 'purchaseReceiptSupplierName',
        },
        {
          title: '成本类型',
          minWidth: 116,
          key: 'purchaseReceiptPayment',
        },
        {
          title: '创建人',
          minWidth: 116,
          key: 'purchaseReceiptCreateUserName',
        },
        {
          title: '创建时间',
          minWidth: 116,
          key: 'purchaseReceiptCreateTime',
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => {
            let disabled = false;
            if (!this.showInspect) {
              disabled = true;
            }
            return h(
              'lk-button',
              {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled,
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'doInspect',
                      params: { purchaseReceiptId: row.purchaseReceiptId },
                    });
                  },
                },
              },
              '生成验货单',
            );
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  methods: {
    // handleSearch() {
    //   this.page = 1;
    //   this.getData();
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      purchase.todoInspectionList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            const purchaseMedicineInfoVoList = [];
            utils.exchangeTable(item, result);
            result.purchaseReceiptPayment = this.paymentType[result.purchaseReceiptPayment - 1];
            result.purchaseReceiptCreateTime = utils.formatTime(result.purchaseReceiptCreateTime, 'YYYY/MM/DD HH:mm');
            utils.exchangeTable();
            result.purchaseMedicineInfoVoList.forEach((infoItem) => {
              const tempResult = {};
              utils.exchangeTable(infoItem, tempResult);
              purchaseMedicineInfoVoList.push(tempResult);
            });
            result.purchaseMedicineInfoVoList = purchaseMedicineInfoVoList;
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page) {
    //   this.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    clear() {
      this.query = {
        inventoryIds: [],
        isDecoction: 2,
        nameMix: '',
      };
    },
  },
  mounted() {
    if (this.handlePermission('doInspect')) {
      this.showInspect = true;
    }
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
